<template>
  <div>
    <div v-if="$apollo.loading">
      <div style="margin-top: 10%;" class="text-center">
        <div class="spinner" />
        <strong>กำลังโหลด..</strong>
      </div>
    </div>
    <div v-else>
      <data-table :data="filtered" :columns="columns" :filters="filters" name="โครงการ" create-link="/projects/create">
        <div slot="toolbar-button">
          <router-link v-if="$auth.user().role === 'student'" class="btn btn-primary" to="/projects/create">ร่างโครงการ</router-link>
        </div>

        <template slot="thead">
          <tr>
            <th width="30">#</th>
            <th>ชื่่อโครงการ</th>
            <th width="200">ประเภทกิจกรรม</th>
            <th>หน่วยงาน</th>
            <th width="200">สถานะ</th>
            <th>การกระทำ</th>
          </tr>
        </template>
      </data-table>
    </div>
  </div>
</template>

<script>
import gql from 'graphql-tag'
import DataTable from '../../components/shared/DataTable'

export default {
  components: {
    DataTable
  },
  apollo: {
    projectProposals: gql`{
      projectProposals {
        _id
        name
        status
        type
        group {
          name
        }
      }
    }`
  },
  data () {
    return {
      filters: [
        { key: 'name', text: 'ชื่อโครงการ' },
        { key: 'type', text: 'ประเภท' }
      ],
      columns: [
        {
          data: null,
          render: (data, type, row, meta) => {
            return meta.row + 1
          }
        },
        {
          data: 'name'
        },
        {
          data: 'type'
        },
        {
          data: 'group.name'
        },
        {
          data: 'status',
          render: (data) => {
            if (data === 'แบบร่าง') {
              return `<span class="label label-default">${data}</span>`
            } else if (data === 'อนุมัติ') {
              return `<span class="label label-success">${data}</span>`
            } else if (data === 'ไม่อนุมัติ') {
              return `<span class="label label-danger">${data}</span>`
            }
            return data
          }
        },
        {
          data: null,
          className: 'table-view-pf-actions text-center text-nowrap',
          render: function (data, type, row, meta) {
            // Inline action button renderer
            return `<div class="table-view-pf-btn"><a href="/projects/${row._id}" class="btn btn-default">ดูข้อมูล</a></div>`
          }
        }
      ]
    }
  },
  computed: {
    filtered () {
      let project = []
      if (this.$auth.user().role === 'advisor') {
        this.projectProposals.forEach(projectProposal => {
          if (projectProposal.status !== 'แบบร่าง') {
            project.push(projectProposal)
          }
        })
      } else if (this.$auth.user().role === 'osda') {
        this.projectProposals.forEach(projectProposal => {
          if (projectProposal.status !== 'แบบร่าง' && projectProposal.status !== 'รอการอนุมัติจากอาจารย์ที่ปรึกษา') {
            console.log(projectProposal)
            project.push(projectProposal)
          }
        })
      } else {
        return this.projectProposals
      }
      return project
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/js/views/projects/Index.vue